import React, { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import Container from '../../../containers/integration/functions/createFunctionContainer';
import { actions } from '../../../redux/integration/functions';

export default function () {
  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(actions.getInitData('\'\''));
  }, []);
  return (
    <Container />
  );
}
